/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSessionsRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListSessionsRequest$inboundSchema: z.ZodType<
  ListSessionsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListSessionsRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListSessionsRequest$outboundSchema: z.ZodType<
  ListSessionsRequest$Outbound,
  z.ZodTypeDef,
  ListSessionsRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listSessionsRequestToJSON(
  listSessionsRequest: ListSessionsRequest,
): string {
  return JSON.stringify(
    ListSessionsRequest$outboundSchema.parse(listSessionsRequest),
  );
}
export function listSessionsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListSessionsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSessionsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSessionsRequest' from JSON`,
  );
}
